export const appendScripts = (shop) => {
	// Currency converter and currencies script
	const shopifyCurrenciesScript = document.createElement("script")
	shopifyCurrenciesScript.src =
		"https://cdn.shopify.com/s/javascripts/currencies.js"
	shopifyCurrenciesScript.async = true
	shopifyCurrenciesScript.onload = () =>
		console.log("Currencies.js loaded", window, window.Currency)
	shopifyCurrenciesScript.onerror = () => {
		console.error("Currencies.js failed to load")
		loadShopifyCurrenciesScriptFallback()
	}
	document.body.appendChild(shopifyCurrenciesScript)

	if (shop) {
		const crispChatIdentifyScript = document.createElement("script")
		crispChatIdentifyScript.innerHTML = `$crisp.push(["set", "user:nickname", ["${shop}"]]);`
		crispChatIdentifyScript.async = true
		document.body.appendChild(crispChatIdentifyScript)
	}
}

const loadShopifyCurrenciesScriptFallback = () => {
	const shopifyCurrenciesScriptFallback = document.createElement("script")
	shopifyCurrenciesScriptFallback.src = "currencies.js"
	shopifyCurrenciesScriptFallback.async = true
	shopifyCurrenciesScriptFallback.onload = () =>
		console.log("Currencies.js fallback loaded", window, window.Currency)
	shopifyCurrenciesScriptFallback.onerror = () =>
		console.error("Currencies.js fallback failed to load")
	document.body.appendChild(shopifyCurrenciesScriptFallback)
}
